<template>
  <div class="agreement">
    <div class="content-box">
      <h1 class="title"><span>安道云课堂用户注册协议</span></h1>
      <article>
        <dl class="contetn">
          <dt>
            <h4>一、总则</h4>
          </dt>
          <dd>
            <span>欢迎使用安道云课堂
              （以下简称“云课堂”）为您提供的各项服务。为了保护网络信息安全，保障公民、法人和其他组织的合法权益，维护国家安全和社会公共利益，依据国家有关法律、法规，本云课堂制定并按照本服务条款提供网络服务。当本条例与国家法律、法规冲突时，以国家法律、法规为准。</span>
            <span>1.请您（以下简称“用户”）充分阅读并同意本条款的全部内容并按照页面上的提示完成全部的注册程序（未成年人应征得其法定监护人的同意）。</span>
            <span>2.用户在注册过程中点击“同意”按钮，即表示用户与云课堂达成协议，自愿接受本服务条款的所有内容，用户选择访问或使用云课堂有关服务，将视为同意接受本条款全部内容的约束。</span>
            <span>3.除非另有明确规定，云课堂所推出的新产品、新功能和新服务，均无条件的适用本条款。</span>
            <span>4.云课堂保留在任何时候修改服务条款的权利，并只公示于本云课堂，无需另行通知，修改后的条款于公示时即时生效。</span>
          </dd>

          <dt>
            <h4>二、注册信息</h4>
          </dt>
          <dd>
            <span>1.用户可以通过注册帐号使用云课堂提供的服务。用户帐号的所有权归云课堂所有，用户完成注册后，获得云课堂帐号的使用权。</span>
            <span>2.用户注册成功后，云课堂将给予每个用户一个用户帐号及相应的密码。用户自行保管其帐号和密码，对以该帐号进行的所有活动和事件负法律责任。</span>
            <span>3.用户应提供完整、真实、准确和最新的个人资料，该资料作为认定用户与其云课堂帐号的关联性以及用户身份的唯一依据。如因注册信息不真实而引起的问题由用户本人承担，云课堂不负任何责任并有权暂停或终止用户的帐号。</span>
            <span>4.用户不应将其帐号、密码转让、借予、售卖等给他人使用，如果云课堂发现使用者并非帐号注册者本人，云课堂有权停止继续服务。如用户帐号和密码遭到他人非法使用或发生其他任何安全问题，用户应当立即通知云课堂。因黑客行为或用户的过错导致帐号、密码被他人非法使用，云课堂不承担任何责任。</span>
          </dd>

          <dt>
            <h4>三、使用规则</h4>
          </dt>

          <dd>
            <span>1.用户对其帐号进行的所有活动和事件（包括但不限于用户发表的任何内容以及由此产生的任何结果）负全部法律责任。</span>
            <span>2.用户在使用云课堂服务时，必须遵守中华人民共和国相关法律、法规的规定，用户应同意将不会利用云课堂进行任何违法或不正当的活动，否则云课堂有权在不通知用户的情况下处理违法内容直至关闭用户账号，包括但不限于下列行为：</span>
            <span class="in2em">1）反对宪法确定的基本原则的；</span>
            <span class="in2em">2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</span>
            <span class="in2em">3）损害国家荣誉和利益的；</span>
            <span class="in2em">4）煽动民族仇恨、民族歧视，破坏民族团结的；</span>
            <span class="in2em">5）煽动非法集会、结社、游行、示威、聚众扰乱社会秩序的；</span>
            <span class="in2em">6）破坏国家宗教政策，宣扬邪教和封建迷信的；</span>
            <span class="in2em">7）散布谣言，扰乱社会秩序，破坏社会稳定的；</span>
            <span class="in2em">8）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</span>
            <span class="in2em">9）侮辱或者诽谤他人，侵害他人合法权益的；</span>
            <span class="in2em">10）含有法律、行政法规禁止的其他内容的；</span>
            <span>3.为使用云课堂服务，用户须自行配备进入网络所必需的设备，包括电脑、手机及其他与接入互联网或移动网有关的装置，并自行支付与此服务有关的费用。</span>
            <span>4.用户不得利用云课堂进行商业行为或商业媒介活动。</span>
          </dd>

          <dt>
            <h4>四、知识产权</h4>
          </dt>
          <dd>
            <span>1.云课堂服务中提供的内容（包括文字、图形、图表、音频、视频、软件等）均受著作权法、商标法或其它法律法规的保护，未经云课堂及相关权利人书面许可，用户不得以任何方式使用或创造相关衍生作品或用于任何商业用途。</span>
            <span>2.本条款未授予用户使用云课堂任何商标、服务标识、域名和其他显著品牌特征的权利。</span>
            <span>3.对于用户上传到本云课堂的任何内容，用户同意云课堂不限区域、形式和载体地享有永久的、不可撤销的、免费的、非独家的使用权和转授权的权利，包括但不限于修改、复制、发行、展览、改编、汇编、出版、翻译、信息网络传播、广播、表演和再创作及著作权法等法律法规确定的其他权利。</span>
            <span>4.云课堂在收到权利人的通知书后，可依其合理判断，删除该等侵犯他人知识产权或其他合法权益的内容。</span>
          </dd>

          <dt>
            <h4>五、隐私权保护</h4>
          </dt>

          <dd>
            <span>1.保护用户的隐私是本云课堂的一项基本原则。未经用户同意，云课堂不对外公开或向第三方提供用户的个人信息，但法律法规另有规定的除外。</span>
            <span>2.云课堂将运用各种安全技术和程序建立完善的管理制度来保护用户的个人信息，以免遭受未经授权的访问、使用或披露。</span>
            <span>3.云课堂可能会与第三方合作向用户提供相关的网络服务，在此情况下，如该第三方同意承担与云课堂同等的保护用户隐私的责任，则云课堂有权将用户的注册资料等提供给该第三方。</span>
            <span>4.用户在注册帐号或使用本服务的过程中，可能需要填写一些必要的信息。若国家法律法规有特殊规定的，用户需要填写真实的身份信息。若用户填写的信息不完整，则无法使用本服务或在使用过程中受到限制。</span>
            <span>5.一般情况下，用户可随时浏览、修改自己提交的信息，但出于安全性和身份识别（如号码申诉服务）的考虑，用户可能无法修改注册时提供的初始注册信息及其他验证信息。</span>
            <span>6.在不透露单个用户隐私资料的前提下，云课堂有权对整个用户数据库进行分析并对用户数据库进行适当的使用。</span>
          </dd>

          <dt>
            <h4>六、免责声明</h4>
          </dt>

          <dd>
            <span>1.鉴于网络服务的特殊性，云课堂不保证网络服务的准确性、及时性、安全性、有效性、合法性和完整性，用户同意云课堂有权不经事先通知，随时变更、中断或终止部分或全部的网络服务，云课堂毋须以任何方式就任何信息传递或传送的失误、不准确或错误对用户和任何第三方均无需承担任何责任。</span>
            <span>2.用户同意其使用云课堂服务所存在的风险及其后果将完全由其自己承担，云课堂对用户不承担任何责任。如因用户违反有关法律、法规或本条款项下的任何条款而给云课堂或任何其他第三方造成损失，用户同意承担由此造成的损害赔偿责任。</span>
            <span>3.用户信息如果不愿意被本云课堂收录，或认为本云课堂的内容可能涉嫌侵犯其合法权益，应该及时向云课堂书面反馈，并提供身份证明、权属证明及详细侵权情况证明，云课堂在收到上述法律文件后，将会尽快删除相关内容。</span>
            <span>4.若要访问和使用本云课堂，用户必须完全接受本条款中所包含的所有内容和本云课堂即时刊登的通知，并且遵守有关互联网、万维网或本云课堂的相关法律、规定与规则。一旦用户访问、使用了本云课堂，即表示同意并接受了所有该等条款、条件及通告。</span>
          </dd>

          <dt>
            <h4>七、其他</h4>
          </dt>

          <dd>
            <span>1.本条款的版权归云课堂所有，云课堂保留对本条款的一切解释和修改权利。</span>
            <span>2.本条款的订立、执行和争议的解决均应适用中华人民共和国法律。如双方就本条款内容或其执行发生任何争议，双方应尽量友好协商解决；协商不成时，任何一方均可向云课堂所在地有管辖权的人民法院提起诉讼。</span>
            <span>3.云课堂未行使本条款的任何权利或规定，不构成对前述权利之放弃。</span>
            <span>4.如本条款中的任何条款完全或部分无效，本条款的其余条款仍有效并且有约束力。</span>
            <span>5.若用户对本条款有任何意见，欢迎垂询云课堂客服中心。</span>
          </dd>
        </dl>
      </article>
    </div>
  </div>
</template>

<script>
export default {
  name: "Agreement"
};
</script>

<style lang='less' scoped>
.agreement {
  width: 100vw;
  height: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 50px;

  .content-box {
    width: 1200px;

    .title {
      text-align: center;
      margin-top: 25px;
    }

    .contetn {
      dt {
        h4{
          font-size: 16px;
          color: #24ba58;
          line-height: 1.6em;
        }
      }
      dd {
        margin-left: 2em;
        line-height: 1.6em;

        .in2em {
          text-indent: 2em;
        }

        span {
          display: block;
          font-size: 14px;
        }
      }
    }
  }
}
</style>